export default "__VITE_ASSET__BHm2smy2__"